import React from 'react';
import { useEffect, useRef } from 'react';
import { DocumentEditorContainerComponent, Toolbar } from '@syncfusion/ej2-react-documenteditor';
import { TitleBar } from './tool-bar';

DocumentEditorContainerComponent.Inject(Toolbar);


// tslint:disable:max-line-length
const CompareFileSFDT = () => {
    let sfdt = localStorage.getItem('diff_sfdt');
    if (sfdt) {
        try {
            sfdt = JSON.stringify(JSON.parse(sfdt)); // ensure valid
            container.current.documentEditor.open(sfdt);
        } catch (err) {
            console.error("Invalid SFDT:", err);
        }
    }

    useEffect(() => {
        rendereComplete();
    }, []);
    let hostUrl = "http://localhost:62870/api/documenteditor/";
    let container = useRef(null);
    let titleBar;
    const onLoadDefault = () => {
        let defaultDocument = {
            sfdt: sfdt
        };
        container.current.documentEditor.open(JSON.stringify(defaultDocument));
        container.current.documentEditor.documentName = "Getting Started";
        titleBar.updateDocumentTitle();
        container.current.documentChange = () => {
            titleBar.updateDocumentTitle();
            container.current.documentEditor.focusIn();
        };
    };
    const rendereComplete = () => {
        window.onbeforeunload = function () {
            return "Want to save your changes?";
        };
        container.current.documentEditor.pageOutline = "#E0E0E0";
        container.current.documentEditor.acceptTab = true;
        container.current.documentEditor.resize();
        titleBar = new TitleBar(document.getElementById("documenteditor_titlebar"), container.current.documentEditor, true);
        onLoadDefault();
    };
    return (<div className="control-pane h-screen">
        <div className="control-section">
            <div id="documenteditor_titlebar" className="e-de-ctn-title"></div>
            <div id="documenteditor_container_body" className='bg-red-700 mt-[-200px]'>
                <DocumentEditorContainerComponent id="container" ref={container} style={{ display: "block" }} height={"110vh" } serviceUrl={hostUrl} enableToolbar={true} locale="en-US" />
            </div>
        </div>
    </div>);
};
export default CompareFileSFDT;
